<template>
  <div>
    <div v-if="sections?.length" class="space-y-6">
      <div
        v-for="(
          { data: sectionData, label: sectionLabel, layout: sectionLayout = 'detailCard' },
          sectionIndex
        ) in sections"
        :key="sectionIndex"
        class="space-y-4"
      >
        <p v-if="sectionLayout === 'bulletin'">
          {{ $t.otherFeatures }}
        </p>
        <dl v-if="sectionLayout === 'keyValue'" class="space-y-4">
          <template v-for="({ label: itemLabel, text, url }, itemIndex) in sectionData" :key="itemIndex">
            <div v-if="itemLabel && text" class="flex gap-x-1 wrap">
              <dt class="fw-bold">
                <product-barcode :text="`${itemLabel}:`" />
              </dt>
              <dd class="fw-normal">
                <base-link v-if="url" :to="url">
                  {{ text }}
                </base-link>
                <product-barcode v-else :text />
              </dd>
            </div>
          </template>
        </dl>
        <component
          :is="componentTypes[resolveLayout(sectionLayout)]"
          v-else
          :class="{ 'fw-normal o:cols-1': sectionLayout === 'bulletin' }"
          :data="sectionData"
          :title="sectionLabel || title"
        />
      </div>
    </div>
    <component
      :is="componentTypes[resolveLayout(layout)]"
      v-else
      :data
      :title
    />
  </div>
</template>

<script lang="ts" setup>
import type { ProductDetailWithSections } from '#types/product'
import {
  LazyProductAccordionsBulletin,
  LazyProductAccordionsDetailCard,
  LazyProductAccordionsGrid,
  LazyProductAccordionsKeyValue,
  LazyProductAccordionsModalGrid,
  LazyProductAccordionsScale
} from '#components'
import { DETAIL_LAYOUTS } from '#root/enums/product'

export type Props = {
  data: ProductDetailWithSections['data']
  layout?: string
  sections?: ProductDetailWithSections['sections']
  title?: string
}

const { data, layout, sections, title } = defineProps<Props>()

type Layout = typeof DETAIL_LAYOUTS[number]
const resolveLayout = (value?: string): Layout =>
  value && (DETAIL_LAYOUTS as readonly string[]).includes(value) ? value as Layout : 'detailCard'

const componentTypes = {
  bulletin: LazyProductAccordionsBulletin,
  detailCard: LazyProductAccordionsDetailCard,
  grid: LazyProductAccordionsGrid,
  keyValue: LazyProductAccordionsKeyValue,
  modalGrid: LazyProductAccordionsModalGrid,
  scale: LazyProductAccordionsScale
}
</script>
